import React from 'react';
import animationProcessing from "url:shared-assets/animations/processing.svg";

interface Props {
  txt?: string;
}

const Loading = (props: Props) => {
  return (
    <div className="w-full h-full flex items-center justify-center">
      <div className="mx-auto">
        <img
          src={animationProcessing}
          className="mx-auto"
          alt="loading"
          style={{height: 16, width: 114}}
        />
        {
          props.txt &&
            <div className="mt-4 text-center z-title2 mx-auto">
              {props.txt}
            </div>
        }
      </div>


    </div>
  );
};

export default Loading;